const createQuery = () => `
  ... on HeaderWidget {
    title
    viewAllCtaLink
    large
  }
`

export default createQuery
